module.exports = __webpack_public_path__ + "static/img_main_event_iam-8f407bb9846a4b5c07f6cc01887edcb5.png";